import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import React, { useEffect } from 'react';
import { ConicalGradient } from './conical-gradient';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

export const BORDER_WIDTH = 2;

interface Props {
  baseStyle?: StyleProp<ViewStyle>;
  children: React.ReactNode;
  innerStyle?: StyleProp<ViewStyle>;
}

export const SnakeBorderView: React.FC<Props> = ({
  baseStyle,
  children,
  innerStyle,
}) => {
  const [styles] = useStyles();

  const rotationAnimation = useSharedValue(0);

  useEffect(() => {
    rotationAnimation.value = withRepeat(
      withTiming(360, {
        duration: 2500,
        easing: Easing.linear,
      }),
      -1,
      false,
    );

    return () => {
      cancelAnimation(rotationAnimation);
    };
  }, [rotationAnimation]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotate: `${rotationAnimation.value}deg`,
        },
      ],
    };
  }, []);

  return (
    <View style={[styles.base, baseStyle]}>
      <Animated.View style={[styles.animatedBackground, animatedStyle]}>
        <ConicalGradient />
      </Animated.View>
      <View style={[styles.inner, innerStyle]}>{children}</View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  animatedBackground: {
    aspectRatio: 1,
    left: 0,
    position: 'absolute',
    right: 0,
  },
  base: {
    borderRadius: 4,
    justifyContent: 'center',
    overflow: 'hidden',
    padding: BORDER_WIDTH,
  },
  inner: {
    backgroundColor: theme.colors.white,
    borderRadius: 2,
    justifyContent: 'center',
  },
}));
